import React from 'react';
import { useLanguage } from '../../src/functions/useLanguage';
import { wt } from '../i18n';

const PERSONAS = [
  {
    titleKey: 'personas.modern.title' as Parameters<typeof wt>[1],
    tagKey: 'personas.modern.tag' as Parameters<typeof wt>[1],
    descKey: 'personas.modern.desc' as Parameters<typeof wt>[1],
    imageUrl:
      'https://images.unsplash.com/vector-1768297633727-df8c891ead55?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTJ8M2swTVhXQmt3eUF8fGVufDB8fHx8fA%3D%3D',
    accent: 'text-primary-brown',
  },
  {
    titleKey: 'personas.elderly.title' as Parameters<typeof wt>[1],
    tagKey: 'personas.elderly.tag' as Parameters<typeof wt>[1],
    descKey: 'personas.elderly.desc' as Parameters<typeof wt>[1],
    imageUrl: '/images/guide/the_elderly_dog_carer.png',
    accent: 'text-indigo-600',
  },
  {
    titleKey: 'personas.farm.title' as Parameters<typeof wt>[1],
    tagKey: 'personas.farm.tag' as Parameters<typeof wt>[1],
    descKey: 'personas.farm.desc' as Parameters<typeof wt>[1],
    imageUrl:
      'https://images.unsplash.com/vector-1753865250494-aaecd8b6da21?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Mzh8M2swTVhXQmt3eUF8fGVufDB8fHx8fA%3D%3D',
    accent: 'text-amber-600',
  },
];

export function Personas() {
  const { language } = useLanguage();
  const t = (key: Parameters<typeof wt>[1]) => wt(language, key);

  return (
    <section className="py-24 text-title-primary">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-4xl lg:text-5xl mb-2 uppercase tracking-tight"
            style={{
              fontFamily: '"Grozen Medical", "Atkinson Hyperlegible", ui-sans-serif, system-ui, sans-serif',
              color: 'var(--title-primary)',
            }}
          >
            {language === 'English' ? (
              <>
                <span
                  style={{
                    fontFamily: '"Grozen Medical", "Atkinson Hyperlegible", ui-sans-serif, system-ui, sans-serif',
                    fontWeight: 700,
                    color: 'var(--title-primary)',
                  }}
                >
                  DESIGNED{' '}
                </span>
                <span
                  style={{
                    fontFamily: '"Grozen Medical", "Atkinson Hyperlegible", ui-sans-serif, system-ui, sans-serif',
                    fontWeight: 300,
                    color: 'var(--title-primary)',
                  }}
                >
                  FOR EVERY{' '}
                </span>
                <span
                  style={{
                    fontFamily: '"Grozen Medical", "Atkinson Hyperlegible", ui-sans-serif, system-ui, sans-serif',
                    fontWeight: 700,
                    color: 'var(--title-primary)',
                  }}
                >
                  COMPANION
                </span>
              </>
            ) : (
              <span
                style={{
                  fontFamily: '"Grozen Medical", "Atkinson Hyperlegible", ui-sans-serif, system-ui, sans-serif',
                  fontWeight: 700,
                  color: 'var(--title-primary)',
                }}
              >
                {t('personas.heading')}
              </span>
            )}
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm leading-relaxed">
            {t('personas.subheading')}
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {PERSONAS.map(({ titleKey, tagKey, descKey, imageUrl, accent }) => (
            <div
              key={titleKey}
              className="rounded-[2rem] overflow-hidden text-left"
            >
              <div className="relative w-full h-[300px]">
                <img
                  src={imageUrl}
                  alt={t(titleKey)}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute bottom-0 inset-x-0 h-40 bg-gradient-to-t from-[#faf8f5] to-transparent" />
              </div>
              <div className="relative z-10 px-6 pb-6 -mt-14">
                <p className={`text-xs font-bold tracking-widest uppercase mb-2 ${accent}`}>
                  {t(tagKey)}
                </p>
                <h3 className="text-xl font-black text-[#0d2744] mb-3">
                  {t(titleKey)}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {t(descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
